import { AUTH, ROUTER } from "../constants/state";
import { call, put, select } from "redux-saga/effects";
import actionTypes from "../actions/actionTypes";
import { OVERLAY_TEXT } from "../constants/overlayTypes";
import config from '../config.json'

export function* overlaySetOverlay(overlayKey, overlayType) {
    yield put({
        type: actionTypes.OVERLAY_SET_TYPE,
        payload: {
            overlayKey: overlayKey,
            overlayType: overlayType
        }
    })
}


export function* putSuccess(successActionType, payload, overlayKey = false) {
    yield put({
        type: successActionType, 
        payload: payload
    })

    if(overlayKey) {
        yield call(overlaySetOverlay, overlayKey, OVERLAY_TEXT)
    }
}

export function* putError(errorActionType, errorMessage, overlayKey = false) {
    yield put({
        type: errorActionType, 
        payload: {
            errorMessage: errorMessage
        }
    })

    if(overlayKey) {
        yield call(overlaySetOverlay, overlayKey, OVERLAY_TEXT)
    }
}

export function* checkResponse(response, dataKey = false) {
    if(!response) {
        throw new Error('No response')
    }

    if(!response.hasOwnProperty('status') || 200 !== response.status) {
        throw new Error('No response with status 200')
    }

    if(!response.hasOwnProperty('data')) {
        throw new Error('No response with data')
    }

    if(dataKey) {
        if(Array.isArray(dataKey)) {
            dataKey.map(k => {
                if(!response.data.hasOwnProperty(k)) {
                    throw new Error('No response with data.' + k)
                }
            })
        } else if(!response.data.hasOwnProperty(dataKey)){
            throw new Error('No response with data.' + dataKey)
        }
    }
}

export const getLocationPathname = state => ({ 
    path: state.getIn([ROUTER, 'location', 'pathname']) 
})


export function* isLoginPage() {
    const { path }  = yield select(getLocationPathname)

    return path === config.routes.login.path
}